export const columnsConfigBySportForDisplay = {
  handball: {
    pointDifference: "goalDifference",
    pointDifferenceAway: "goalDifferenceAway",
    pointDifferenceHome: "goalDifferenceHome",
  },
  hockey: {
    pointDifference: "goalDifference",
    pointDifferenceAway: "goalDifferenceAway",
    pointDifferenceHome: "goalDifferenceHome",
  },
};

export const columnsConfigBySportForData = {
  handball: {
    goalDifference: "pointDifference",
    goalDifferenceAway: "pointDifferenceAway",
    goalDifferenceHome: "pointDifferenceHome",
  },
  hockey: {
    goalDifference: "pointDifference",
    goalDifferenceAway: "pointDifferenceAway",
    goalDifferenceHome: "pointDifferenceHome",
  },
};

export const renameStandingPropertiesByConfig = (data, config) => {
  if (!config) {
    return data;
  }

  return Object.keys(data).reduce(
    (acc, key) => ({
      ...acc,
      ...{ [config[key] || key]: data[key] },
    }),
    {},
  );
};

export const defaultPointsSchema = {
  CONFERENCE: {
    gamesBehind: 0,
  },
  DIVISION: {
    gamesBehind: 0,
  },
  IN_CONFERENCE: {
    bonusStandingPoints: 0,
    byeStandingPoints: 0,
    gamesBehind: 0,
    penaltyStandingPoints: 0,
    standingPoints: 0,
    standingPointsAway: 0,
    standingPointsHome: 0,
    teamDifferential: 0,
    teamDifferentialAway: 0,
    teamDifferentialHome: 0,
  },
  IN_DIVISION: {
    bonusStandingPoints: 0,
    byeStandingPoints: 0,
    gamesBehind: 0,
    penaltyStandingPoints: 0,
    standingPoints: 0,
    standingPointsAway: 0,
    standingPointsHome: 0,
    teamDifferential: 0,
    teamDifferentialAway: 0,
    teamDifferentialHome: 0,
  },
  OUT_CONFERENCE: {
    bonusStandingPoints: 0,
    byeStandingPoints: 0,
    gamesBehind: 0,
    penaltyStandingPoints: 0,
    standingPoints: 0,
    standingPointsAway: 0,
    standingPointsHome: 0,
    teamDifferential: 0,
    teamDifferentialAway: 0,
    teamDifferentialHome: 0,
  },
  OUT_DIVISION: {
    bonusStandingPoints: 0,
    byeStandingPoints: 0,
    gamesBehind: 0,
    penaltyStandingPoints: 0,
    standingPoints: 0,
    standingPointsAway: 0,
    standingPointsHome: 0,
    teamDifferential: 0,
    teamDifferentialAway: 0,
    teamDifferentialHome: 0,
  },
  OVERALL: {
    bonusStandingPoints: 0,
    byeStandingPoints: 0,
    gamesBehind: 0,
    penaltyStandingPoints: 0,
    standingPoints: 0,
    standingPointsAway: 0,
    standingPointsHome: 0,
    teamDifferential: 0,
    teamDifferentialAway: 0,
    teamDifferentialHome: 0,
  },
};

export const defaultCalculatedSchema = {
  IN_CONFERENCE: {
    byes: 0,
    draws: 0,
    drawsAway: 0,
    drawsHome: 0,
    forfeitsGiven: 0,
    forfeitsWonBy: 0,
    highestScoreAgainst: null,
    highestScoreAgainstAway: null,
    highestScoreAgainstHome: null,
    highestScoreFor: null,
    highestScoreForAway: null,
    highestScoreForHome: null,
    losses: 0,
    lossesAway: 0,
    lossesHome: 0,
    lowestScoreAgainst: null,
    lowestScoreAgainstAway: null,
    lowestScoreAgainstHome: null,
    lowestScoreFor: null,
    lowestScoreForAway: null,
    lowestScoreForHome: null,
    percentage: 0,
    percentageAway: 0,
    percentageHome: 0,
    played: 0,
    playedAway: 0,
    playedHome: 0,
    pointDifference: 0,
    pointDifferenceAway: 0,
    pointDifferenceHome: 0,
    resultString: "",
    resultStringAway: "",
    resultStringHome: "",
    scoredAgainst: 0,
    scoredAgainstAway: 0,
    scoredAgainstHome: 0,
    scoredFor: 0,
    scoredForAway: 0,
    scoredForHome: 0,
    streak: 0,
    streakAway: 0,
    streakHome: 0,
    washouts: 0,
    winPercentage: 0,
    winPercentageAway: 0,
    winPercentageHome: 0,
    wins: 0,
    winsAway: 0,
    winsHome: 0,
  },
  IN_DIVISION: {
    byes: 0,
    draws: 0,
    drawsAway: 0,
    drawsHome: 0,
    forfeitsGiven: 0,
    forfeitsWonBy: 0,
    highestScoreAgainst: null,
    highestScoreAgainstAway: null,
    highestScoreAgainstHome: null,
    highestScoreFor: null,
    highestScoreForAway: null,
    highestScoreForHome: null,
    losses: 0,
    lossesAway: 0,
    lossesHome: 0,
    lowestScoreAgainst: null,
    lowestScoreAgainstAway: null,
    lowestScoreAgainstHome: null,
    lowestScoreFor: null,
    lowestScoreForAway: null,
    lowestScoreForHome: null,
    percentage: 0,
    percentageAway: 0,
    percentageHome: 0,
    played: 0,
    playedAway: 0,
    playedHome: 0,
    pointDifference: 0,
    pointDifferenceAway: 0,
    pointDifferenceHome: 0,
    resultString: "",
    resultStringAway: "",
    resultStringHome: "",
    scoredAgainst: 0,
    scoredAgainstAway: 0,
    scoredAgainstHome: 0,
    scoredFor: 0,
    scoredForAway: 0,
    scoredForHome: 0,
    streak: 0,
    streakAway: 0,
    streakHome: 0,
    washouts: 0,
    winPercentage: 0,
    winPercentageAway: 0,
    winPercentageHome: 0,
    wins: 0,
    winsAway: 0,
    winsHome: 0,
  },
  OUT_CONFERENCE: {
    byes: 0,
    draws: 0,
    drawsAway: 0,
    drawsHome: 0,
    forfeitsGiven: 0,
    forfeitsWonBy: 0,
    highestScoreAgainst: null,
    highestScoreAgainstAway: null,
    highestScoreAgainstHome: null,
    highestScoreFor: null,
    highestScoreForAway: null,
    highestScoreForHome: null,
    losses: 0,
    lossesAway: 0,
    lossesHome: 0,
    lowestScoreAgainst: null,
    lowestScoreAgainstAway: null,
    lowestScoreAgainstHome: null,
    lowestScoreFor: null,
    lowestScoreForAway: null,
    lowestScoreForHome: null,
    percentage: 0,
    percentageAway: 0,
    percentageHome: 0,
    played: 0,
    playedAway: 0,
    playedHome: 0,
    pointDifference: 0,
    pointDifferenceAway: 0,
    pointDifferenceHome: 0,
    resultString: "",
    resultStringAway: "",
    resultStringHome: "",
    scoredAgainst: 0,
    scoredAgainstAway: 0,
    scoredAgainstHome: 0,
    scoredFor: 0,
    scoredForAway: 0,
    scoredForHome: 0,
    streak: 0,
    streakAway: 0,
    streakHome: 0,
    washouts: 0,
    winPercentage: 0,
    winPercentageAway: 0,
    winPercentageHome: 0,
    wins: 0,
    winsAway: 0,
    winsHome: 0,
  },
  OUT_DIVISION: {
    byes: 0,
    draws: 0,
    drawsAway: 0,
    drawsHome: 0,
    forfeitsGiven: 0,
    forfeitsWonBy: 0,
    highestScoreAgainst: null,
    highestScoreAgainstAway: null,
    highestScoreAgainstHome: null,
    highestScoreFor: null,
    highestScoreForAway: null,
    highestScoreForHome: null,
    losses: 0,
    lossesAway: 0,
    lossesHome: 0,
    lowestScoreAgainst: null,
    lowestScoreAgainstAway: null,
    lowestScoreAgainstHome: null,
    lowestScoreFor: null,
    lowestScoreForAway: null,
    lowestScoreForHome: null,
    percentage: 0,
    percentageAway: 0,
    percentageHome: 0,
    played: 0,
    playedAway: 0,
    playedHome: 0,
    pointDifference: 0,
    pointDifferenceAway: 0,
    pointDifferenceHome: 0,
    resultString: "",
    resultStringAway: "",
    resultStringHome: "",
    scoredAgainst: 0,
    scoredAgainstAway: 0,
    scoredAgainstHome: 0,
    scoredFor: 0,
    scoredForAway: 0,
    scoredForHome: 0,
    streak: 0,
    streakAway: 0,
    streakHome: 0,
    washouts: 0,
    winPercentage: 0,
    winPercentageAway: 0,
    winPercentageHome: 0,
    wins: 0,
    winsAway: 0,
    winsHome: 0,
  },
  OVERALL: {
    byes: 0,
    draws: 0,
    drawsAway: 0,
    drawsHome: 0,
    forfeitsGiven: 0,
    forfeitsWonBy: 0,
    highestScoreAgainst: null,
    highestScoreAgainstAway: null,
    highestScoreAgainstHome: null,
    highestScoreFor: null,
    highestScoreForAway: null,
    highestScoreForHome: null,
    losses: 0,
    lossesAway: 0,
    lossesHome: 0,
    lowestScoreAgainst: null,
    lowestScoreAgainstAway: null,
    lowestScoreAgainstHome: null,
    lowestScoreFor: null,
    lowestScoreForAway: null,
    lowestScoreForHome: null,
    percentage: 0,
    percentageAway: 0,
    percentageHome: 0,
    played: 0,
    playedAway: 0,
    playedHome: 0,
    pointDifference: 0,
    pointDifferenceAway: 0,
    pointDifferenceHome: 0,
    resultString: "",
    resultStringAway: "",
    resultStringHome: "",
    scoredAgainst: 0,
    scoredAgainstAway: 0,
    scoredAgainstHome: 0,
    scoredFor: 0,
    scoredForAway: 0,
    scoredForHome: 0,
    streak: 0,
    streakAway: 0,
    streakHome: 0,
    washouts: 0,
    winPercentage: 0,
    winPercentageAway: 0,
    winPercentageHome: 0,
    wins: 0,
    winsAway: 0,
    winsHome: 0,
  },
};
